import { Response as GetApplicationCheckStatusResponse } from 'api/typegen/client/application/check-status/get';
import fetchWebApi from 'api/fetchWebApi';

const getLoanApplicationCheckStatusApiCall =
  async (): Promise<GetApplicationCheckStatusResponse> =>
    fetchWebApi('/client/application/check-status');

export default getLoanApplicationCheckStatusApiCall;
